import * as qiniu from "qiniu-js";

const err_service="网络请求异常"
const err_login="登陆异常"
// const qiniuUploader = require("../3rd/qiniuUploader");

export default class qiniuService {
  static async uploadImgArr(qiniuInfoArr,imgArr){
    return new Promise(async (resolve,reject) => {
      let resultArr=[];
      imgArr.map(async (val,idx)=>{
        let url=await this.uploadImg(val.file,qiniuInfoArr[idx])
        console.log('uploadImg url =='+url);
        let result={
          url:url,
        }
        if(val.seq!=undefined){
          result.seq=val.seq;
        }
        if(val.id!=undefined){
          result.id=val.id;
        }
        resultArr.push(result)
        
        if(resultArr.length == imgArr.length){
          resolve(resultArr)
        }
      })
    })
  }

  static async uploadHuashuVideoArr(qiniuInfoArr,videoArr){
    console.log('uploadHuashuVideoArr...');
    return new Promise(async (resolve,reject) => {
      let resultArr=[];
      videoArr.forEach(async (val,idx)=>{
        let url=await this.uploadVideo(val.file,qiniuInfoArr[idx])
        let qrPosterUrl=await this.uploadImg(val.posterFile,{
          uploadKey:qiniuInfoArr[idx].imageKey,
          qiniuToken:qiniuInfoArr[idx].imageToken
        })
        let result={
          url:url,
          qrPosterUrl:qrPosterUrl,
        }
        if(val.seq!=undefined){
          result.seq=val.seq;
        }
        if(val.id!=undefined){
          result.id=val.id;
        }
        resultArr.push(result)
        
        if(resultArr.length == videoArr.length){
          resolve(resultArr)
        }
      })
    })
  }

  static changeFileName(filename) {
    return filename.replace(/.[a-zA-Z0-9]+$/, (match) => {
        return `-${Date.now()}${match}`
    })
  }

  /*上传图片至七牛云*/
  static async uploadImg(file,qiniuInfo){
    let key=qiniuInfo.uploadKey;
    let token=qiniuInfo.qiniuToken;
    return new Promise( async (resolve,reject) => {
      const config = {
          useCdnDomain: true,
          region:null
      };

      const putExtra = {
          fname: this.changeFileName(file.name)
      };
      var observable =  await qiniu.upload(file, key, token, putExtra,config);
      await observable.subscribe(
        (res)=>{
          //next
        },
        (err)=>{
          //error
          console.log("qiniu.upload error:",error);
          reject(err)
        },
        (res)=>{
          //complete
          console.log("qiniu.upload complete:",res);
          resolve(res)
        },
      );
    })
  }

  /*上传视频至七牛云*/
  static async uploadVideo(file,qiniuInfo){
    let key=qiniuInfo.uploadKey;
    let token=qiniuInfo.qiniuToken;

    return new Promise( async (resolve,reject) => {
      const config = {
          useCdnDomain: true,
          region:null
      };

      const putExtra = {
          fname: this.changeFileName(file.name)
      };
      var observable =  await qiniu.upload(file, key, token, putExtra,config);
      await observable.subscribe(
        (res)=>{
          //next
        },
        (err)=>{
          //error
          console.log("qiniu.upload error:",error);
          reject(err)
        },
        (res)=>{
          //complete
          console.log("qiniu.upload complete:",res);
          resolve(res)
        },
      );
    })
  }
}